import React from "react";
import { BadgeCheck, Headphones } from "lucide-react";
import { useApp } from "../context/AppContext";

export default function ArtistHero() {
  const { artist } = useApp();

  return (
    <section className="relative -mt-14">
      <div className="relative h-[460px] w-full overflow-hidden">
        <img
          src={artist.heroImage}
          alt={artist.name}
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 smoke-overlay" />

        <div className="absolute left-0 right-0 bottom-0 px-5 pb-5">
          <div className="rise flex items-center gap-1.5 mb-2">
            {artist.verified && (
              <span className="flex items-center gap-1 text-[10px] tracking-[0.18em] uppercase text-white/75">
                <BadgeCheck size={13} className="text-[#8b5cf6]" />
                S71 Verified
              </span>
            )}
          </div>
          <h1 className="font-display text-white leading-[0.92] text-[54px] sm:text-[62px] uppercase rise">
            {artist.name}
          </h1>
          <div className="mt-2 flex items-center gap-3 text-[11px] tracking-[0.14em] uppercase text-white/55 rise">
            <span>{artist.genre}</span>
            <span className="w-1 h-1 rounded-full bg-white/30" />
            <span>{artist.songs.length} Tracks</span>
            <span className="w-1 h-1 rounded-full bg-white/30" />
            <span className="flex items-center gap-1">
              <Headphones size={12} /> {artist.monthlyListeners}
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
